import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import { DxTreeListComponent } from 'devextreme-angular';
import { ProjectService } from '../../../core/project.service';
import { ProjectStructure } from '../../models/projects.model';
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'app-structure-treelist',
  templateUrl: './structure-treelist.component.html',
  styleUrls: ['./structure-treelist.component.scss'],
})
export class StructureTreelistComponent implements OnInit, OnDestroy {
  @Input() types: string[] = [];
  @Input() projectId: number = 0;
  @Input() projectTitle: string = 'titulo de projecto';
  @Input() mode: 'search' = 'search';

  private _searchValue: string = '';
  @Input() set searchValue(value: string) {
    this._searchValue = value;
  }
  get searchValue(): string {
    return this._searchValue;
  }

  loading: boolean = true;

  @Output() EntitySelected = new EventEmitter<number>();

  @ViewChild('treeView') treeView: DxTreeListComponent | undefined;

  public dataSource: ProjectStructure[] = [] as ProjectStructure[];

  private destroy$: Subject<void> = new Subject<void>();
  constructor(private projectService: ProjectService) {}

  ngOnInit(): void {
    this.projectService
      .getStructureOfAProject(this.projectId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: ProjectStructure[]) => {
        this.dataSource = data;
        this.loading = false;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onSelectionChange(value: any) {
    this.EntitySelected.emit(value.selectedRowKeys[0]);
  }
}
